import { render } from "./site-selector.vue?vue&type=template&id=28d19fa8&ts=true"
import script from "./site-selector.vue?vue&type=script&lang=ts"
export * from "./site-selector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__